<div class="lm-flex-row-responsive-container">
    <ng-container [ngTemplateOutlet]="PDF"></ng-container>
    <ng-container *ngIf="model.charts" [ngTemplateOutlet]="INITIAL_VIEW"></ng-container>
    <ng-container *ngIf="reportCatalogEnabled && model.isReport" [ngTemplateOutlet]="REPORT"></ng-container>

</div>
<ng-template #PDF>
    <div class="lm-report-widget">
        <h2 class="fieldset-title">{{ 'PrintToFile' | translate }}</h2>
        <div class="field field-radio lm-padding-top">
            <input
                    data-automation-id="lm-personalization-pdf-landscape-orientation"
                    type="radio" class="radio" id="landscape" value="landscape" [(ngModel)]="model.orientation" soho-trackdirty />
            <label for="landscape" class="radio-label">{{'PDFOrientationLandscape' | translate}}</label>
            <input
                    data-automation-id="lm-personalization-pdf-portrait-orientation"
                    type="radio" class="radio" id="portrait" value="portrait" [(ngModel)]="model.orientation" soho-trackdirty />
            <label for="portrait" class="radio-label">{{'PDFOrientationPortrait' | translate}}</label>
        </div>
        <div class="field lm-padding-right">
            <label soho-label for="lm-personalization-pdf-font-offset-option">{{'PDFFontSizeOffset' | translate}}</label>
            <select data-automation-id="lm-personalization-pdf-font-offset-option" class="dropdown-md"
                    soho-dropdown
                    id="lm-personalization-pdf-font-offset-option"
                    [attributes]="pdfFontOffsetOptionDropdownAttributes"
                    noSearch soho-trackdirty
                    (change)="onFontOffsetOptionChange($event)"
                    [(ngModel)]="model.fontOffsetOption"
            >
                <option [value]="'default'">{{'PDFFontSizeOffsetDefault' | translate}}</option>
                <option [value]="'small'">{{'PDFFontSizeOffsetSmall' | translate}}</option>
                <option [value]="'smaller'">{{'PDFFontSizeOffsetSmaller' | translate}}</option>
                <option [value]="'smallest'">{{'PDFFontSizeOffsetSmallest' | translate}}</option>
                <option [value]="'custom'">{{'PDFFontSizeOffsetCustom' | translate}}</option>
            </select>
        </div>
        <div *ngIf="model.fontOffsetOption === 'custom'" class="field lm-no-label two columns" >
            <label soho-label for="lm-personalization-pdf-font-offset"></label>
            <!-- soho-spin box doesn't have an attributes input. So instead attributes is
                being placed on the data-options attribute. That will then get picked up by
                spinbox.js in ids-enterprise.
            -->
            <input data-automation-id="lm-personalization-pdf-font-offset"
                   class="input-xs"
                   soho-spinbox
                   id="lm-personalization-pdf-font-offset"
                   attr.data-options="{{customFontOffsetSpinBoxDataOptions}}"
                   [(ngModel)]="model.fontOffset"/>
        </div>
        <div *ngIf="!(model.listType === 'tree' || model.listType === 'cube')" class="field lm-padding-right">
            <label soho-label for="lm-personalization-page-size-option">{{ 'PageSize' | translate }}</label>
            <select data-automation-id="lm-personalization-page-size-option" class="dropdown-md"
                    soho-dropdown
                    id="lm-personalization-page-size-option"
                    [attributes]="pageSizeOptionDropdownAttributes"
                    noSearch soho-trackdirty
                    [(ngModel)]="model.showLines"
            >
                <option *ngFor="let pageSize of pageSizes" [value]="pageSize">{{ pageSize }}</option>
            </select>
        </div>
        <div class="field">
            <input
                    soho-checkbox
                    type="checkbox"
                    soho-trackdirty
                    id="lm-personalization-show-grd-lines-checkbox"
                    name="lm-personalization-show-grd-lines-checkbox"
                    data-automation-id="lm-personalization-show-grd-lines-checkbox"
                    [(ngModel)]="model.showGridLines"
            >
            <label
                    soho-label
                    for="lm-personalization-show-grd-lines-checkbox"
                    [forCheckBox]="true">{{'Show_Grid_Lines' | translate}}</label>
        </div>
        <div class="field">
            <input
                    soho-checkbox
                    type="checkbox"
                    soho-trackdirty
                    id="lm-personalization-show-header-checkbox"
                    name="lm-personalization-show-header-checkbox"
                    data-automation-id="lm-personalization-suppress-header-checkbox"
                    [(ngModel)]="model.suppressHeader"
            >
            <label
                    soho-label
                    for="lm-personalization-show-header-checkbox"
                    [forCheckBox]="true">{{'Suppress_Headers' | translate}}</label>
        </div>
        <div class="field">
            <input
                    soho-checkbox
                    type="checkbox"
                    soho-trackdirty
                    id="lm-personalization-show-footer-checkbox"
                    name="lm-personalization-show-footer-checkbox"
                    data-automation-id="lm-personalization-suppress-footer-checkbox"
                    [(ngModel)]="model.suppressFooter"
            >
            <label
                    soho-label
                    for="lm-personalization-show-footer-checkbox"
                    [forCheckBox]="true">{{'Suppress_Footer' | translate}}</label>
        </div>
    </div>
</ng-template>

<ng-template #INITIAL_VIEW>
    <div class="lm-report-widget">
        <h2 class="fieldset-title">{{'CreateReportDefViewLabel' | translate}}</h2>
        <div class="field">
            <select soho-dropdown
                    id="viewName"
                    name="viewName"
                    data-automation-id="lm-personalization-view-name"
                    [attributes]="viewNameDropdownAttributes"
                    [source]="viewNameSource"
                    [(ngModel)]="model.viewName"
                    soho-trackdirty
            >
                <option [value]="'list'">{{ 'list' | translate }}</option>
                <option *ngFor="let viewName of model.charts" [value]="viewName">{{viewName}}</option>
            </select>
        </div>
    </div>
</ng-template>

<ng-template #REPORT>
    <div class="lm-report-widget">
        <h2 class="fieldset-title">{{ 'ListPersonalizationApplicationReportAndCategory' | translate }}</h2>
        <div class="field">
            <label
                    soho-label
                    for="lm-personalization-app-report-module"
            >
                {{ 'ListPersonalizationModule' | translate }}
            </label>
            <select
                    data-automation-id="lm-personalization-app-report-module"
                    id="lm-personalization-app-report-module"
                    name="lm-personalization-app-report-module"
                    attr.placeholder="Available Category"
                    soho-dropdown
                    soho-trackdirty
                    soho-alert
                    [id]="'lm-personalization-app-report-module'"
                    [moveSelected]="true"
                    [(ngModel)]="model.module"
                    (ngModelChange)="onModuleChanged()"
                    soho-busyindicator
                    blockUI="true"
                    displayDelay="0"
                    [source]="onModuleSelect"
            >
                <option *ngFor="let item of appReport.modules"
                        selected="{{item?.selected}}"
                        [value]="item?.value">{{item?.label}}
                </option>
            </select>
        </div>
        <div class="field">
            <label
                    soho-label
                    for="lm-personalization-app-report-category"
            >
                {{ 'ListPersonalizationCategory' | translate }}
            </label>
            <select
                    data-automation-id="lm-personalization-app-report-category"
                    id="lm-personalization-app-report-category"
                    name="lm-personalization-app-report-category"
                    attr.placeholder="Available Subcategory"
                    soho-dropdown
                    soho-trackdirty
                    soho-alert
                    [id]="'lm-personalization-app-report-category'"
                    [moveSelected]="true"
                    [(ngModel)]="model.category"
                    soho-busyindicator
                    blockUI="true"
                    displayDelay="0"
                    [source]="onCategorySelect"
            >
                <option
                        *ngFor="let item of appReport.categories"
                        selected="{{item?.selected}}"
                        [value]="item?.value">{{item?.label}}
                </option>
            </select>
        </div>
        <div class="field">
            <label
                soho-label
                for="lm-personalization-app-report-description"
            >{{ 'Description' | translate }}
            </label>
            <textarea
              [attr.id]="'reportDescription'"
              data-automation-id="lm-personalization-app-report-description"
              name="reportDescription"
              spellcheck="true"
              soho-textarea
              soho-alert
              [id]="'lm-personalization-app-report-description'"
              soho-trackdirty
              [(ngModel)]="model.description">
            </textarea>
        </div>
    </div>
</ng-template>

